import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { TAPIR_PASSWORD_RESET_URL } from '../Config';

const SignIn: React.FC = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { userToken, signIn } = useAuth();

    useEffect(() => {
        if (userToken) {
            navigate("/");
        }
    }, [navigate, userToken]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const success = await signIn(email, password);
        if (success) {
            navigate("/");
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3>Sign in to MHC Attention</h3>
            <p>MHC Attention uses the same credentials as TAPIR.</p>
            <div>
                <label>Email: </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div>
                <label>Password: </label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} />
            </div>
            <div className="account_links">
                <p><Link to="/signup">Create account</Link></p>
                <p><a href={TAPIR_PASSWORD_RESET_URL}>Forgot password?</a></p>
            </div>
            <input type="submit" value="Sign In"></input>
        </form>
    );
};

export default SignIn;
